const fonts = {
  primary: 'GT America',
};

export default fonts;
